import { createSlice } from '@reduxjs/toolkit';
import { deleteSchedule } from "../../api/calendar/delete";

export const deleteCalendarSlice = createSlice({
    name: 'calendar/delete',
    initialState: {
        request: false,
        messageTitle: '',
        message: '',
        outcome: 'pending',
    },
    reducers: {
        showError(state, action) {
            state.request = false;
            state.outcome = 'fail';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        showSuccess(state, action) {
            state.request = false;
            state.outcome = 'success';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        cancelError(state) {
            state.request = false;
            state.outcome = 'pending';
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(deleteSchedule.pending, (state, action) => {
                state.request = true;
            })
            .addCase(deleteSchedule.fulfilled, (state, action) => {
                state.request = false;
                state.outcome = 'success';
                state.message = '';
            })
            .addCase(deleteSchedule.rejected, (state, action) => {
                const { payload } = action;
                state.request = false;
                state.outcome = 'fail';
                state.messageTitle = 'Error';
                //@ts-ignore
                state.message = payload?.message || 'Failed to delete schedule';
            })
    },
});

export const { cancelError, showError, showSuccess } = deleteCalendarSlice.actions

export default deleteCalendarSlice.reducer;
